import { FormControl } from "@angular/forms";

export function nomeValidator(control: FormControl) {
  const re = new RegExp(/^[A-Za-zÀ-ÖØ-öø-ÿ]+(([',. -][A-Za-zÀ-ÖØ-öø-ÿ ])?[A-Za-zÀ-ÖØ-öø-ÿ]*)*$/);

  if (control.value != undefined && control.value != '' && !re.test(control.value))
    return {
      nome: true
    }
  return null;
}

